import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';

function DialersFormStatus(props) {
    const { t } = useTranslation();

    const renderStatus = (data) => {
        let text = "formclosed"
        if (props.dialer.campaign != null && props.dialer.campaign.length > 0)
            text = "formopened";


        return (<Tooltip style={{ position: "fixed" }} {...data}>{t(text)}</Tooltip>);
    }

    const getStatus = () => {
        let content = <FontAwesomeIcon className="px-1 text-muted" size="lg" icon={duotone("file-lines")} />

        if (props.dialer.campaign != null && props.dialer.campaign.length > 0)
            content = <FontAwesomeIcon className={"px-1 text-warning"} size="lg" icon={duotone("file-lines")} />
        return content;
    }

    return (<OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={renderStatus}>
        <div style={{ display: "inline-block" }}>
            {getStatus()}
        </div>
    </OverlayTrigger>);
}


export default DialersFormStatus;